import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOmega: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOmega"><Path d="M3.5 19.5V21.5H9.5V17.9359C6.32361 16.8942 4.03125 13.9214 4.03125 10.4167C4.03125 6.04441 7.59898 2.5 12 2.5C16.401 2.5 19.9688 6.04441 19.9688 10.4167C19.9688 13.9214 17.6764 16.8942 14.5 17.9359L14.5 21.5H20.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconOmega;
